import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ProgressBar,
} from "react-bootstrap";
import { CSVLink } from "react-csv";
import { ChargingBASE_URL } from "../../Config";


import { OverlayTrigger, Tooltip } from "react-bootstrap";

const columns = [
  {
    name: "Timestamp",
    selector: (row) => row.timestamp,
    sortable: true,
  },
  {
    name: "Reason",
    selector: (row) => row.reason,
    sortable: true,
    cell: (row) => (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-reason-${row.transactionId}`}>
            {row.reason || "No Reason Provided"}
          </Tooltip>
        }
      >
        <span
          className="text-truncate"
          style={{
            display: "inline-block",
            maxWidth: "150px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer"
          }}
        >
          {row.reason}
        </span>
      </OverlayTrigger>
    ),
  },
  
  {
    name: "Amount",
    selector: (row) => row.amount,
    sortable: true,
  },
  {
    name: "Account Number",
    selector: (row) => row.account_Number,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
  },
  {
    name: "Transaction ID",
    selector: (row) => row.transactionId,
    sortable: true,
  },
  {
    name: "Digital_Consent",
    selector: (row) => row.digital_Consent,
    sortable: true,
  },
];


const PartnerReportByNo = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [msisdn, setMsisdn] = useState("");
  const [msisdnError, setMsisdnError] = useState("");
  const [userId, setUserId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserId(user.userId);
    }
  }, []);

  const handleChange = (e) => {
    const input = e.target.value.replace(/\D/g, ""); // Only digits

    if (!input.startsWith("92") && input.length >= 2) {
      setMsisdnError("MSISDN must start with 92");
    } else {
      setMsisdnError("");
    }

    if (input.length <= 12) {
      setMsisdn(input);
    }
  };

  const fetchData = async () => {
    if (!msisdn) {
      setError("MSISDN is required");
      return;
    }

    const url = new URL(`${ChargingBASE_URL}JazzcashReportByNo`);
    url.search = new URLSearchParams({
      UserId: userId,
      Msisdn: msisdn,
    }).toString();

    try {
      setIsLoading(true);
      setProgress(1);

      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 5;
        });
      }, 100);

      const response = await fetch(url, { method: "GET", headers: { Accept: "*/*" } });

      if (!response.ok) throw new Error("Failed to fetch data");

      const result = await response.json();
      setData(result);
      setFilteredData(result);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!msisdn.startsWith("92")) {
      setMsisdnError("MSISDN must start with 92");
      return;
    }
    fetchData();
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((row) =>
        [
          row.agentName,
          row.companyName,
          row.timestamp,
          row.reason,
          row.amount?.toString(),
          row.account_Number?.toString(),
          row.status,
          row.transactionId?.toString(),
        ]
          .filter(Boolean)
          .some((field) => field.toLowerCase().includes(query.toLowerCase()))
      );
      setFilteredData(filtered);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="text-center mt-2">
          <ProgressBar animated now={progress} label={`Loading Data... ${progress}%`} />
        </div>
      )}

      {error && <div className="text-danger text-center mt-2">{error}</div>}

      <Row className="justify-content-center">
        <Col lg={10} md={12} sm={12}>
          <Card className="mt-2 shadow-lg">
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col md={4} sm={6}>
                    <Form.Group controlId="msisdn">
                      <Form.Control
                        type="text"
                        placeholder="Enter MSISDN"
                        value={msisdn}
                        className="mt-4"
                        onChange={handleChange}
                        required
                      />
                      {msisdnError && (
                        <div className="text-danger small mt-1">{msisdnError}</div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4} sm={6}>
                    <Button
                      variant="primary"
                      type="submit"
                      className="mt-4 w-100"
                      disabled={isLoading}
                    >
                      {isLoading ? "Loading..." : "Search"}
                    </Button>
                  </Col>

                  <Col md={4} sm={6}>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearch}
                      className="mt-4"
                    />
                  </Col>
                </Row>
              </Form>

              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                responsive
                highlightOnHover
                striped
                dense
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 15, 20]}
              />

              {filteredData.length > 0 && !isLoading && (
                <CSVLink
                  data={filteredData}
                  filename={"transaction_report.csv"}
                  className="btn btn-success mt-1 w-100"
                >
                  Download CSV
                </CSVLink>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PartnerReportByNo;
